<template>
    <div class="row">
      <div v-if="amfData.records && !amfData.records.length" class="col-12 text-center my-5">
          Aucune information AMF disponible pour cette valeur.
      </div>
      <div v-if="amfData.records && amfData.records.length" class="col-12">
          <div>
            <base-table :data="amfData.records" thead-classes="text-primary">
                <template slot="columns">
                    <th style="min-width: 110px">Date</th>
                    <th class="text-left">Information</th>
                    <th></th>
                </template>
                <template slot-scope="{ row }">
                    <td>
                        <p class="title">{{ $moment((row.fields.informationdeposee_inf_dat_emt)).format('ll') }}</p>
                    </td>
                    <td>
                        <p class="title">{{ row.fields.informationdeposee_inf_tit_inf }}</p>
                        <p class="text-muted">{{ row.fields.sous_type_d_information }}</p>
                    </td>
                    <td class="text-right">
                        <el-tooltip
                            content="Consulter le document"
                            effect="light"
                            :open-delay="300"
                            placement="top">
                            <a :href="row.fields.url_de_recuperation" target="_blank">
                                <i class="tim-icons icon-attach-87 m-2" style="font-size: 1.7em;"></i>
                            </a>
                        </el-tooltip>
                    </td>
                </template>
            </base-table>
          </div>
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                {{ from + 1 }}-{{ to }} / {{ total }} communiqués
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="currentPage"
              :per-page="pagination.perPage"
              :total="total">
            </base-pagination>
          </div>
      </div>
    </div>
</template>

<script>

import { BasePagination, BaseTable } from 'src/components';
import { mapGetters } from 'vuex';
import { getAMFDeclarations } from '../../../dao/amf'

export default {
  name: 'amfTable',
  props: {
    instrument: {
      type: Object,
      default: () => {}
    },
  },
  components: {
    BasePagination,
    BaseTable
  },
  computed: {
    currentPosition() {
      return this.$store.getters['auth/getPosition'](this.$store.getters['instruments/current'].isin)
    },
    ...mapGetters({
      userConf: 'auth/conf',
    }),
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.currentPage - 1);
    },
    total() {
      return this.amfData.nhits;
    }
  },
  provide() {
    return { };
  },
  data() {
    return {
        pagination: {
            perPage: 20,
            total: 0
        },
        currentPage: 1,
        amfData: [],
    };
  },
  methods: {
    async init( instrument ) {
        if( instrument.mk === "XPAR" ) {
            this.currentPage = 1;
            this.amfData = await getAMFDeclarations(instrument, 0, this.pagination.perPage);
            this.amfData.records = this.amfData.records.sort((a,b) => b.fields.informationdeposee_inf_dat_emt.localeCompare(a.fields.informationdeposee_inf_dat_emt))
        } else {
            this.amfData = {
                records: []
            }
        }
    },
  },
  async mounted() {
      await this.init(this.instrument);
  },
  watch: {
    async instrument(newValue, oldValue) {
      if( newValue && oldValue && newValue.isin != oldValue.isin) {
        await this.init( newValue );
      }
    },
    async currentPage(newValue, oldValue) {
        if(newValue !== oldValue) {
            this.amfData = await getAMFDeclarations(this.instrument, (newValue-1)*this.pagination.perPage, this.pagination.perPage);
            this.amfData.records = this.amfData.records.sort((a,b) => b.fields.informationdeposee_inf_dat_emt.localeCompare(a.fields.informationdeposee_inf_dat_emt))
        }
    }
  },
};
</script>

<style scoped>
</style>